import { RouterProvider } from 'react-router';
import { SWRConfig } from 'swr';
import { fetcher } from 'shared/api';
import { router } from './router';

const App = () => {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        refreshInterval: 0,
        shouldRetryOnError: false,
        //errorRetryCount: 3,
        fetcher,
        //onError: (error, key) => {}
      }}
    >
      <RouterProvider router={router} />
    </SWRConfig>
  );
};

export default App;
